import { transparentize } from "polished"; 

export default {
    Modal: {
        parts: [
            "modal",
            "overlay",
            "dialog",
            "header",
            "footer",
            "body",
            "closeButton" 
        ],
        baseStyle: {
            overlay: {
                // eslint-disable-next-line no-magic-numbers
                bgColor: ({ colors }) => transparentize(0.7, colors.secondary["700"])
            },
            
            dialog: {
                overflow: "hidden",
            },
            dialogContainer: {
                bgColor: "unset"
            }
        },
        sizes: {
            xxl: {
                dialog: { maxW: "46rem" }
            },
        },
        defaultProps: {},
    }
};
